const SubsidiariesNames = [
    {id: 0, name: 'Panamá'},
    {id: 1, name: 'Penonomé'},
    {id: 2, name: 'David'},
    {id: 3, name: 'Santa Elena'}
]

export default SubsidiariesNames
